import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import constant from '../../../utils/Constant';
import config from '../../../config/config';
import Loader from '../../partials/Loader';

const {
    UPDATE_CATERER_QUOTATION_END_POINT,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    STATUS_200,
    STATUS_401,
    LOGOUT,
} = constant;

const UpdateCaterer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const caterer = location.state?.catererData || [];

    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    const [formData, setFormData] = useState({
        _id: caterer.id,
        vendorId: caterer.vendor_id,
        fullName: caterer.full_name,
        email: caterer.email,
        phone: caterer.phone,
        eventDate: caterer.event_date,
        startTime: caterer.start_time,
        endTime: caterer.end_time,
        eventType: caterer.event_type,
        event_type_other: caterer.event_type_other,
        otherEventType: caterer.event_type,
        guests: caterer.no_of_guest,
        venueName: caterer.venue_name,
        venueAddress: caterer.venue_address,
        vendorAccess: caterer.loading_access,
        catering_style: caterer.catering_style,
        catering_style_other: caterer.catering_style_other,
        menu_type: caterer.menu_type.map((pre) => pre),
        beverages: caterer.beverages,
        serving_staff: caterer.serving_staff,
        budget: caterer.budget_range,
        notes: caterer.note,
        serving_staff: caterer.serving_staff,
        catering_setup: caterer.catering_setup,
        req_tableware: caterer.req_tableware,
        status: caterer.status,
    });

    // * guest option for selection
    const guestOptions = ['50–75', '76–100', '101–150', '151–200', '201–250', '251–300', '301–400', '401–500', '500+'];

    //* handle change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prevForm) => {
            if (type === 'checkbox') {
                const currentValues = prevForm[name] || [];
                const updatedValues = checked
                    ? [...currentValues, value]
                    : currentValues.filter((item) => item !== value);
                return { ...prevForm, [name]: updatedValues };
            }

            // Radio buttons and other inputs
            return { ...prevForm, [name]: value };
        });
    };

    // * budget option for selection
    const budgetOptions = [
        'R5,000–R10,000', 'R10,001–R15,000', 'R15,001–R25,000',
        'R25,001–R50,000', 'R50,001–R75,000',
        'R75,001–R100,000', 'R100,001+'
    ];

    // * bar option for selection
    const barOptions = [
        'Buffet', 'Canapés/Finger Food', 'Plated Meal', 'Food Stations', 'Braai-style', 'Grazing Table',
    ];

    // * execute update caterer api
    const executeUpdateCatererApi = async () => {

        // * set loading and disable button
        setLoading(trueValue);
        setDisableButton(trueValue);

        const sendRequest = {
            vendor_id: formData.vendorId,
            full_name: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            event_date: formData.eventDate,
            start_time: formData.startTime,
            end_time: formData.endTime,
            event_type: formData.eventType,
            event_type_other: formData.event_type_other,
            no_of_guest: formData.guests,
            venue_name: formData.venueName,
            venue_address: formData.venueAddress,
            loading_access: formData.vendorAccess,
            catering_style: formData.catering_style,
            catering_style_other: formData.catering_style_other,
            beverages: formData.beverages,
            menu_type: formData.menu_type.map((pre) => pre),
            serving_staff: formData.serving_staff,
            req_tableware: formData.req_tableware,
            catering_setup: formData.catering_setup,
            budget_range: formData.budget,
            status: formData.status,
            note: formData.notes,
            id: formData._id
        }

        try {
            const apiUrl = `${config.appBaseUrl + UPDATE_CATERER_QUOTATION_END_POINT}`;

            // * execute put request
            const response = await axios.post(apiUrl, sendRequest, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const apiResponse = response.data;

            // * if response is success
            if (apiResponse.code === STATUS_200) {
                toast.success(apiResponse.message)
            }
        } catch (error) {
            handleError(error);
            // * if token is expired
            if (error.response?.data.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setLoading(falseValue);
            setDisableButton(falseValue);
        }
    };

    //* handle error
    const handleError = (error) => {
        const errorData = error.response?.data?.data;

        if (errorData && typeof errorData === 'object') {
            const firstKey = Object.keys(errorData)[0];
            const firstMessage = errorData[firstKey][0];
            toast.error(firstMessage);
        } else {
            toast.error('Something was broken!');
        }
    }; 

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className='page-content px-4' style={{ zIndex: '1' }}>
                <div className='container-fluid'>
                    {/* //* start page title */}
                    <div className='row'>
                        <div className='col-12 px-0'>
                            <div className='page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>Update Quotation</h4>

                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0 d-flex flex-wrap gap-1'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active pointer' onClick={() => navigate(-1)}>Quotations</li>
                                        <li className='breadcrumb-item active'>Update Quotation</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <form>
                                    <div className='row'>
                                        {/* //* left side */}
                                        <div className='col-12 col-md-6'>
                                            <h5 className='fw-bold quotation-title'>Contact Information:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Full Name</label>
                                                    <input type='text' name='fullName' className='form-control m-0' value={formData.fullName} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Email Address</label>
                                                    <input type='email' name='email' className='form-control m-0' value={formData.email} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Phone Number</label>
                                                    <input type='text' name='phone' className='form-control m-0' value={formData.phone} required onChange={handleChange} />
                                                </div>
                                            </div>

                                            <h5 className='fw-bold quotation-title'>Event Details:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Event Date</label>
                                                    <input type='date' name='eventDate' className='form-control' min={new Date().toISOString().split('T')[0]} value={formData.eventDate} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Catering Start Time</label>
                                                    <input
                                                        type='time'
                                                        name='startTime'
                                                        className='form-control'
                                                        value={formData.startTime}
                                                        required
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Catering End Time</label>
                                                    <input
                                                        type='time'
                                                        name='endTime'
                                                        className='form-control'
                                                        value={formData.endTime}
                                                        required
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Estimated Number of Guests</label>
                                                    <select name='guests' className='form-control' value={formData.guests} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        {guestOptions.map((guest) => (
                                                            <option key={guest} value={guest}>{guest}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Event Type</label>
                                                    <select name='eventType' className='form-control' value={formData.eventType} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        <option value='Wedding'>Wedding</option>
                                                        <option value='Birthday'>Birthday</option>
                                                        <option value='Corporate Event'>Corporate Event</option>
                                                        <option value='Private Party'>Private Party</option>
                                                        <option value='Product Launch'>Product Launch</option>
                                                        <option value='Other'>Other</option>
                                                    </select>
                                                    {formData.eventType === 'Other' && (
                                                        <input
                                                            type='text'
                                                            name='event_type_other'
                                                            className='form-control mt-3'
                                                            placeholder='Please specify'
                                                            value={formData.event_type_other || ''}
                                                            onChange={handleChange}
                                                        />
                                                    )}

                                                </div>
                                            </div>

                                            <h5 className='fw-bold quotation-title'>Location Details:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Venue Name</label>
                                                    <input type='text' name='venueName' className='form-control m-0' value={formData.venueName} onChange={handleChange} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='mb-0 fw-normal'>Venue Address / Location</label>
                                                    <input type='text' name='venueAddress' className='form-control m-0' value={formData.venueAddress} required onChange={handleChange} />
                                                </div>
                                                <div className='col-md-12'>
                                                    <label className='mb-0 fw-normal'>Will the vendor have easy access for loading/unloading?</label>
                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='vendorAccess'
                                                            value='Yes'
                                                            id='accessYes'
                                                            className='form-check-input'
                                                            checked={formData.vendorAccess === 'Yes'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='accessYes'>Yes</label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='vendorAccess'
                                                            value='No'
                                                            id='accessNo'
                                                            className='form-check-input'
                                                            checked={formData.vendorAccess === 'No'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='accessNo'>No</label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='vendorAccess'
                                                            value='Unsure'
                                                            id='accessUnsure'
                                                            className='form-check-input'
                                                            checked={formData.vendorAccess === 'Unsure'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='accessUnsure'>Unsure</label>
                                                    </div>
                                                </div>


                                                <div className='row'>
                                                    <div className='col-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mt-2'>
                                                        <label htmlFor='status_vendor' className='fw-normal mb-0'>Status</label>
                                                        <select
                                                            name='status'
                                                            id='status_vendor'
                                                            className='form-select'
                                                            value={formData.status}
                                                            onChange={handleChange}
                                                        >
                                                            <option value=''>Select status</option>
                                                            <option value='0'>New</option>
                                                            <option value='1'>Replied</option>
                                                            <option value='2'>Close</option>
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        {/* //* right side */}
                                        <div className='col-12 col-md-6'>
                                            <h5 className='fw-bold quotation-title'>Catering Requirements:</h5>
                                            <div className='row'>
                                                {/* <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal'>Catering Style</label>
                                                    <select
                                                        name='catering_style'
                                                        className='form-control'
                                                        required
                                                        onChange={handleChange}
                                                        value={formData.catering_style}
                                                    >
                                                        <option value=''>Select</option>
                                                        {barOptions.map((bar) => (
                                                            <option key={bar} value={bar}>{bar}</option>
                                                        ))}
                                                        <option value='Other'>Other</option>
                                                    </select>
                                                </div>

                                                {formData.catering_style === 'Other' && (
                                                    <div className='col-md-6 mb-3'>
                                                        <label className='fw-normal'>Specify Other Catering</label>
                                                        <input
                                                            type='text'
                                                            name='catering_style_other'  // Match the state key
                                                            className='form-control m-0'
                                                            value={formData.catering_style_other || ''}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                )} */}


                                                <div className='col-md-12 mb-3'>
                                                    <label className='fw-normal'>Menu Type</label>
                                                    <div className='formData-check d-flex flex-wrap gap-3'>
                                                        {['Meat-based', 'Vegetarian', 'Vegan', 'Halaal', 'Gluten-Free', 'Kid-Friendly Options', 'Not sure / Open to suggestions'].map((item) => (
                                                            <div key={item}>
                                                                <input
                                                                    className='formData-check-input'
                                                                    type='checkbox'
                                                                    name='menu_type'
                                                                    value={item}
                                                                    checked={formData.menu_type.includes(item)}
                                                                    onChange={handleChange}
                                                                    id={item}
                                                                />
                                                                <label className='formData-check-label ms-1 fw-normal' htmlFor={item}>
                                                                    {item}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>

                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>Do you require serving staff?</label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='serving_staff'
                                                            value='Yes'
                                                            id='servingYes'
                                                            className='form-check-input'
                                                            required
                                                            checked={formData.serving_staff === 'Yes'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='servingYes'>Yes</label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='serving_staff'
                                                            value='No'
                                                            id='servingNo'
                                                            className='form-check-input'
                                                            checked={formData.serving_staff === 'No'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='servingNo'>No</label>
                                                    </div>
                                                </div>

                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>
                                                        Do you require cutlery/crockery/tableware?
                                                    </label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='req_tableware' // Ensure this matches the state key
                                                            value='Yes – Full service'
                                                            id='tablewareYesFullservice'
                                                            checked={formData.req_tableware === 'Yes – Full service'} // Check the state value
                                                            className='form-check-input'
                                                            onChange={handleChange} // Handle change
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='tablewareYesFullservice'>
                                                            Yes – Full service
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='req_tableware' // Ensure this matches the state key
                                                            value='No – Will be provided'
                                                            id='tablewareNoWillbeprovided'
                                                            checked={formData.req_tableware === 'No – Will be provided'} // Check the state value
                                                            className='form-check-input'
                                                            onChange={handleChange} // Handle change
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='tablewareNoWillbeprovided'>
                                                            No – Will be provided
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='req_tableware' // Ensure this matches the state key
                                                            value='Partial – Please specify in notes'
                                                            id='tablewarePartialPleasesspecifyinnotes'
                                                            checked={formData.req_tableware === 'Partial – Please specify in notes'} // Check the state value
                                                            className='form-check-input'
                                                            onChange={handleChange} // Handle change
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='tablewarePartialPleasesspecifyinnotes'>
                                                            Partial – Please specify in notes
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>
                                                        Do you need catering setup (tables, linen, décor, etc.)?
                                                    </label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='catering_setup'
                                                            value='Yes'
                                                            id='cateringYes'
                                                            className='form-check-input'
                                                            checked={formData.catering_setup === 'Yes'}
                                                            required
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='cateringYes'>
                                                            Yes
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='catering_setup'
                                                            value='No'
                                                            id='cateringNo'
                                                            className='form-check-input'
                                                            checked={formData.catering_setup === 'No'}
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='cateringNo'>
                                                            No
                                                        </label>
                                                    </div>
                                                </div>


                                                {/* <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal d-block'>
                                                        Do you require beverages from this vendor?
                                                    </label>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='beverages_requirement'
                                                            value='Yes'
                                                            id='beveragesYes'
                                                            checked={formData.beverages === 'Yes'}
                                                            className='form-check-input'
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='beveragesYes'>
                                                            Yes
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='beverages_requirement'
                                                            value='No'
                                                            id='beveragesNo'
                                                            checked={formData.beverages === 'No'}
                                                            className='form-check-input'
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='beveragesNo'>
                                                            No
                                                        </label>
                                                    </div>

                                                    <div className='form-check'>
                                                        <input
                                                            type='radio'
                                                            name='beverages_requirement'
                                                            value='Not sure yet'
                                                            id='beveragesNotSure'
                                                            checked={formData.beverages === 'Not sure yet'}
                                                            className='form-check-input'
                                                            onChange={handleChange}
                                                        />
                                                        <label className='form-check-label fw-normal' htmlFor='beveragesNotSure'>
                                                            Not sure yet
                                                        </label>
                                                    </div>
                                                </div> */}

                                            </div>

                                            <h5 className='fw-bold quotation-title'>Budget Range:</h5>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <label className='fw-normal'>Approximate Budget</label>
                                                    <select name='budget' className='form-control' value={formData.budget} required onChange={handleChange}>
                                                        <option value=''>Select</option>
                                                        {budgetOptions.map((b) => (
                                                            <option key={b} value={b}>{b}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <h5 className='fw-bold quotation-title'>Additional Notes:</h5>
                                            <div className=''>
                                                <textarea
                                                    name='notes'
                                                    rows='4'
                                                    className='form-control'
                                                    placeholder='E.g., themes, special dish requests, dietary restrictions, cultural preferences, setup constraints, etc.'
                                                    value={formData.notes || ''}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </form>

                                <div className='d-flex align-items-center justify-content-end mt-3'>
                                    <button className='btn btn-primary' onClick={executeUpdateCatererApi} disabled={disableButton}>
                                        {!loading ? 'Update' : <Loader />}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default UpdateCaterer